module.exports = __webpack_public_path__ + "static/img/cn.f6609864.svg";